import { RootState } from '../../types/rootState';

export const getInitialFrame = (state: RootState): number => state.player.initialFrame;

export const getInFrame = (state: RootState): number | null => state.player.inFrame;

export const getOutFrame = (state: RootState): number | null => state.player.outFrame;
